// extracted by mini-css-extract-plugin
module.exports = {"userMenu":"topbar-user-menu-trigger_userMenu__OScHA","skelAvatar":"topbar-user-menu-trigger_skelAvatar__tZOXC","anonyMenu":"topbar-user-menu-trigger_anonyMenu__EmkWC"};